var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_vm._l((_vm.data),function(item,index){return _c('div',{key:index},[_c('NotificationDisplay',{attrs:{"value":item}})],1)}),_c('ozi-loading',{attrs:{"loading":!_vm.data}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }